import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { appHeightChanged } from '../../../actions/app-actions'
import Giftcard from './Giftcard'

class GiftcardState extends React.Component {
    constructor() {
        super();


    }
    componentDidMount() {
        const { actions, movies, organizerIds, iframeId } = this.props
        console.log(iframeId)
        if (window.parent != window) actions.appHeightChanged(iframeId, true);
        else window.scrollTo(0, 0);
        // if (window.parent != window) actions.appHeightChanged(iframeId, true, false, true);

    }
    componentWillUnmount() {
        const { actions, iframeId } = this.props;
        if (window.parent != window) actions.appHeightChanged(iframeId, true);
        else sessionStorage.setItem("scroll-position", window.scrollY);
    }



    render() {

        console.log('giftcard state')
        return (
            <Giftcard />
        )
    }
}

const mapStateToProps = (state, ownProps) => {


    return {

    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        actions: bindActionCreators(Object.assign({}, { appHeightChanged, }), dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(GiftcardState)